import { useEffect, useState } from 'react';
import type { SessionUser } from '@/app/types/SessionUser';
import { libraryApi } from '@/services/libraryApi';

/** The ids on the signed-in reader's reading list; empty for an anonymous visitor. */
export function useSavedLibraryIds(user: SessionUser | null): Set<string> {
  const [savedIds, setSavedIds] = useState<Set<string>>(new Set());
  useEffect(() => {
    if (!user) return;
    libraryApi
      .savedIds()
      .then((ids) => setSavedIds(new Set(ids)))
      // A reading list that will not load must not cost the reader the library.
      .catch(() => setSavedIds(new Set()));
  }, [user]);
  return savedIds;
}
